import React from "react";
import { CircularProgress } from "@material-ui/core";
import { SW_LOGO } from "../../../../../../../actions/api";

export function SplashScreen() {
  return (
    <div className="studio-content">
      <div id="splash-screen" className="splash-screen">
        <img
          src={SW_LOGO}
          alt="display logo" width={"200px"} height={"60px"}
        />
        <CircularProgress className="splash-screen-spinner" />
      </div>
    </div>
  );
}
